var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShortStay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    fill: "#ff8c08",
    stroke: "#ff8c08",
    strokeWidth: 6.656000000000001,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:#ff8c08;} "), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M118.375,218.637c21.455,0,38.843-17.392,38.843-38.842c0-21.459-17.388-38.843-38.843-38.843 c-21.45,0-38.842,17.384-38.842,38.843C79.533,201.245,96.925,218.637,118.375,218.637z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M98.03,277.821h359.946c14.217,0.04,27.374-4.87,36.898-13.534c4.75-4.308,8.608-9.524,11.26-15.335 c2.652-5.803,4.098-12.208,4.098-18.758c0-6.542-1.455-13.181-4.308-19.345c-4.252-9.275-11.55-17.311-20.945-23.396 c-9.419-6.108-20.904-10.416-34.462-12.883l-0.635-0.105l-247.108-36.994c-5.822-0.868-11.83,0.867-16.291,4.709 c-4.465,3.842-7.069,9.524-7.069,15.424v79.525H98.03c-11.236,0-20.346,9.114-20.346,20.35 C77.684,268.707,86.794,277.821,98.03,277.821z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.092,296.321V124.307c0-13.294-10.765-24.047-24.051-24.047C10.766,100.261,0,111.013,0,124.307v287.432 h48.092v-67.325h415.807v67.325H512V296.321H48.092z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortStay);
export default __webpack_public_path__ + "static/media/short_stay.5d56e035623a9c8939bf5228ef6384d2.svg";
export { ForwardRef as ReactComponent };